import { render } from "./nimp_logo_image.vue?vue&type=template&id=5da0b05e&scoped=true"
import script from "./nimp_logo_image.vue?vue&type=script&lang=js"
export * from "./nimp_logo_image.vue?vue&type=script&lang=js"

import "./nimp_logo_image.vue?vue&type=style&index=0&id=5da0b05e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da0b05e"]])

export default __exports__